// @ts-ignore wat https://www.destroyallsoftware.com/talks/wat
// @ts-nocheck
                        
import type * as SchemaTypes from '../../../../../../graphql/api/index';

import { CmsImageSizesFragmentDoc } from '../../../../cmsImageSizes.fragment.generated';
import { ImageCommonFragmentDoc } from '../../../../imageCommon.fragment.generated';
import { ImageSizeFragmentDoc } from '../../../../imageSize.fragment.generated';
import { QuestionnaireConditionFragmentDoc } from '../../condition/QuestionnaireCondition.fragment.generated';
import { QuestionnaireConditionIsEmptyFragmentDoc } from '../../condition/rules/QuestionnaireConditionIsEmpty.fragment.generated';
import { QuestionnaireConditionIsEqualToFragmentDoc } from '../../condition/rules/QuestionnaireConditionIsEqualTo.fragment.generated';
import { QuestionnaireConditionIsGreaterThanFragmentDoc } from '../../condition/rules/QuestionnaireConditionIsGreaterThan.fragment.generated';
import { QuestionnaireConditionIsLessThanFragmentDoc } from '../../condition/rules/QuestionnaireConditionIsLessThan.fragment.generated';
import { QuestionnaireConditionIsNotEmptyFragmentDoc } from '../../condition/rules/QuestionnaireConditionIsNotEmpty.fragment.generated';
import { QuestionnaireConditionNotIsEqualToFragmentDoc } from '../../condition/rules/QuestionnaireConditionNotIsEqualTo.fragment.generated';
import { QuestionnaireConditionEqualToChoiceFragmentDoc } from '../../condition/rules/QuestionnaireConditionChoiceEqualTo.generated';
export const QuestionnaireQuestionChoiceOptionContentIconCardConditionalFragmentDoc = `
    fragment questionnaireQuestionChoiceOptionContentIconCardConditional on QuestionnaireQuestionChoiceOptionContentIconCardConditional {
  icon {
    ...cmsImageSizes
  }
  title
  description
  conditions {
    ...questionnaireCondition
  }
}
    `;